import { render, staticRenderFns } from "./editSchool.vue?vue&type=template&id=2a0494f8&"
import script from "./editSchool.vue?vue&type=script&lang=js&"
export * from "./editSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports